import getQueryParams from '@/utilities/getters/getQueryParams';

export type ResolveJackpotModeInput = {
  jackpotModeParam: string | null;
  swjEnabled: boolean;
  swjFlagEnabled: boolean;
  swjExperimentEnabled: boolean;
  showGameWindow: boolean;
  isLaunch?: boolean;
};

// Pure so both callers can pass their own state: the UI feeds reactive selector
// values while the launch path feeds useStore.getState() values.
export const resolveJackpotMode = ({
  jackpotModeParam,
  swjEnabled,
  swjFlagEnabled,
  swjExperimentEnabled,
  showGameWindow,
  isLaunch = false,
}: ResolveJackpotModeInput): boolean => {
  // An explicit "continue without jackpots" URL param must win over derivation.
  if (jackpotModeParam === 'false') return false;

  // At launch there is nothing to derive from yet, so the param is all we have;
  // if aggregation later disagrees, useJackpotModeGlsReconcile relaunches the
  // game in the correct mode.
  if (isLaunch && jackpotModeParam === 'true') return true;

  return (
    swjEnabled &&
    (swjFlagEnabled || swjExperimentEnabled || jackpotModeParam === 'true') &&
    showGameWindow
  );
};

export const getJackpotModeParam = (): string | null =>
  getQueryParams('jackpotMode');
